import React from "react";
import { cellState, Offering, STAGES } from "../../config/offeringCatalog";
import { GRID_COLUMNS, NAME_CELL_SPAN } from "../../config/accentStyles";
import MatrixCell from "../MatrixCell/MatrixCell";

interface OfferingRowProps {
  offering: Offering;
  /** Shown when rows are grouped by stage, so each row still names its category. */
  showCategory: boolean;
}

const OfferingRow: React.FC<OfferingRowProps> = ({
  offering,
  showCategory,
}) => (
  <div
    className={`grid ${GRID_COLUMNS} border-b border-gray-100 dark:border-slate-700/50 bg-white dark:bg-slate-800`}
  >
    <div className={`min-w-0 px-4 py-3 md:px-5 ${NAME_CELL_SPAN}`}>
      <div className="flex flex-wrap items-baseline gap-x-2.5 gap-y-0.5">
        <span className="text-sm font-medium text-gray-900 dark:text-white">
          {offering.name}
        </span>
        {showCategory && (
          <span className="text-[11px] font-medium text-gray-500 dark:text-gray-400">
            {offering.category}
          </span>
        )}
      </div>
      <p className="mt-0.5 text-[12.5px] leading-snug text-gray-500 dark:text-gray-400">
        {offering.description}
      </p>
    </div>
    {STAGES.map((stage) => (
      <MatrixCell
        key={stage}
        stage={stage}
        state={cellState(offering, stage)}
      />
    ))}
  </div>
);

export default OfferingRow;
